<template lang="pug">
  a(@click="downloadTemplate" download)
    b-loading(:active.sync="isLoading" :can-cancel="false")
    slot
</template>

<script>
import {getMasterData} from '../utils/api'

export default {
  name: 'DownloadMasterData',
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    downloadTemplate() {
      this.isLoading = true

      getMasterData().then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'masterdata.xlsx')
        document.body.appendChild(link)
        link.click()
      }).catch((error) => {
        alert(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DownloadMasterData.vue